import { createApp } from 'vue';
import App from './App.vue';
import router from './router'; // Import the router

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import "./main.css";
import i18n from "./i18n";

const app = createApp(App);
app.use(router); // Use the router
app.use(i18n);

app.mount('#app');
